<template>
  <div class="item-con" :class="{ 'large-font-mode': pageData.largeFontMode }">
    <div class="label-con flex flex-row align-center">
      <div class="icon" />
      <div class="label">常用</div>
    </div>
    <div class="content">
      <div class="flex flex-row">
        <el-form label-width="80px" size="small" inline style="width: 100%;" :disabled="['2','3','4'].indexOf( pageData.activeDiagRecord.diagRecord.stateSign)>-1">
          <el-row v-if="pageData.type == 4">
            <el-col :span="24">
              <el-form-item label="主诉" class="treatment-form-item">
                <key-word2
                  v-model="pageData.activeDiagRecord.treatmentRecord.symContent"
                  code="sym"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="四诊" class="treatment-form-item">
                <key-word2
                  v-model="pageData.activeDiagRecord.treatmentRecord.fdmContent"
                  code="fdm"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中医病" class="treatment-form-item">
                <key-word2
                  v-model="pageData.activeDiagRecord.treatmentRecord.chDiagContent"
                  code="chDiag"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中医症" class="treatment-form-item">
                <key-word2
                  v-model="pageData.activeDiagRecord.treatmentRecord.chYndromeContent"
                  code="chYndrome"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col v-if="pageData.type == 1||pageData.type == 4" :span="24">
              <el-form-item label="中医病" class="treatment-form-item">
                <key-word
                  id="key1"
                  :key="'chDiag-' + pageData.type"
                  v-model="pageData.activeDiagRecord.treatmentRecord.chDiagContent"
                  code="chDiag"
                  :placeholder="placeholderMap['chDiag']"
                  @change="handleOtherFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="pageData.type == 3||pageData.type == 4" :span="24">
              <el-form-item label="中医症" class="treatment-form-item">
                <key-word
                  id="key2"
                  :key="'sym-' + pageData.type"
                  v-model="pageData.activeDiagRecord.treatmentRecord.chYndromeContent"
                  code="sym"
                  :placeholder="placeholderMap['sym']"
                  :query-params="{
                    symDictionaryCommonSign: '1',
                    symDictionaryMainSign: '1',
                  }"
                  @change="handleOtherFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="pageData.type == 2||pageData.type == 4" :span="24">
              <el-form-item label="西医病" class="treatment-form-item">
                <key-word
                  id="key3"
                  :key="'diag-' + pageData.type"
                  v-model="pageData.activeDiagRecord.treatmentRecord.diagContent"
                  code="diag"
                  :placeholder="placeholderMap['diag']"
                  @change="handleOtherFieldChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="主诉" class="treatment-form-item">
                <chief-complaint
                  v-model="pageData.activeDiagRecord.treatmentRecord.symContent"
                  :diag-params="diagParams"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="pageData.type == 4" :span="24">
              <el-form-item label="四诊" class="treatment-form-item">
                <key-word
                  id="key4"
                  v-model="pageData.activeDiagRecord.treatmentRecord.fdmContent"
                  code="fdm"
                  :placeholder="placeholderMap['fdm']"
                  @change="handleOtherFieldChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import KeyWord from "@/views/business/page/treatment/KeyWord2.vue"
import KeyWord2 from "@/views/business/page/treatment/KeyWord.vue"
import ChiefComplaint from "@/views/business/page/treatment/ChiefComplaint.vue"
export default {
  components: {
    KeyWord,
    ChiefComplaint,
    KeyWord2
  },
  inject: ["pageData"],
  data() {
    return {
      diagParams: {
        code: 'chDiag', // 默认类型，避免 ChiefComplaint 中 dynamicField 为 undefined
        diagDictionaryCode: '', // 中医病名（现在接口支持用名称查询）
        pinyinCode: '',
        commonSign: '',
        mainSign: 1,
        chiefData: '' // 编码（接口未返回，保持空）
      },
      selectedKeywordsMap: {},
      chifeData: {},
      // 新增：用于设置placeholder的字段映射
      placeholderMap: {
        'chDiag': '请选择中医病',
        'sym': '请选择中医症',
        'diag': '请选择西医病',
        'fdm': '请选择四诊'
      }
    }
  },
  // 新增 watch：接口返回中医病名后，自动同步到 diagParams
  watch: {
    'pageData.activeDiagRecord.treatmentRecord.chDiagContent': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.diagParams = {
            ...this.diagParams,
            code: 'chDiag',
            diagDictionaryCode: newVal // 同步中医病名
          }
        }
      }
    }
  },
  methods: {
    // 处理其他字段变化
    handleOtherFieldChange(data) {
      const { code, selectedKeywords } = data
      this.selectedKeywordsMap[code] = selectedKeywords

      // 关键修改：当KeyWord2组件有选择时，清空ChiefComplaint的值
      if (selectedKeywords && selectedKeywords.length > 0) {
        this.pageData.activeDiagRecord.treatmentRecord.symContent = ''
      }

      // 新增：将 code 存入 diagParams
      this.diagParams = {
        code: code,
        diagDictionaryCode: this.getDiagDictionaryCode(),
        commonSign: this.getCommonSign(code),
        mainSign: this.getMainSign(code)
      }
      this.get()
    },

    // 获取诊断字典代码
    getDiagDictionaryCode() {
      const { chDiagContent, diagContent } = this.pageData.activeDiagRecord.treatmentRecord
      return chDiagContent || diagContent || ''
    },

    // 根据code获取commonSign
    getCommonSign(code) {
      const keywords = this.selectedKeywordsMap[code] || []
      if (keywords.length === 0) return ''
      const targetField = `${code}DictionaryCommonSign`
      return keywords[0][targetField] || ''
    },

    // 根据code获取mainSign
    getMainSign(code) {
      const keywords = this.selectedKeywordsMap[code] || []
      if (keywords.length === 0) return ''
      const targetField = `${code}DictionaryMainSign`
      return keywords[0][targetField] || ''
    },

    // 根据code获取动态字典值
    getDynamicDictionaryValue(code) {
      const keywords = this.selectedKeywordsMap[code] || []
      if (keywords.length === 0) return ''
      return keywords[0][`${code}DictionaryCode`] || ''
    },

    get() {
      this.diagParams.chiefData = this.getDynamicDictionaryValue(this.diagParams.code)
    }
  }
}
</script>

<style scoped lang="scss">
.item-con {
  .label-con {
    margin-bottom: 12px;

    .icon {
      width: 4px;
      height: 14px;
      background: #165DFF;
      border-radius: 0 0 0 0;
      margin-right: 8px;
    }

    .label {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: bold;
      font-size: 16px;
      color: #1D2129;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

.treatment-form-item {
  margin-bottom: 5px;
  width: 100%;
}

/* 大字模式样式 */
.large-font-mode {
  font-size: 1.2em;

  .label-con {
    .label {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .el-form-item {
    margin-bottom: 10px;

    ::v-deep .el-form-item__label {
      font-size: 15px;
      line-height: 32px;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-input-number .el-input__inner {
      font-size: 15px;
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input-number {
      line-height: 34px;
    }
  }

  .el-col {
    margin-bottom: 8px;
  }
}

/* 响应式调整 */
@media (max-width: 1366px) {
  .large-font-mode {
    .el-form-item {
      ::v-deep .el-form-item__label {
        font-size: 14px;
      }
      ::v-deep .el-input__inner {
        font-size: 14px;
      }
    }
  }
}
</style>
